'use es6';

// A language's key in I18n and its official language value can be different, so we have to
// do a lookup for an object with the correct language value
export default (options, language, multi) => {
  if (!multi) {
    const langKey = Object.keys(options).find(
      (lang) => options[lang].language === language
    );
    return options[langKey];
  }

  const langKeyObject = {};
  Object.keys(options).forEach((key) => {
    langKeyObject[options[key].language] = options[key];
  });
  return language.map((lang) => {
    return langKeyObject[lang];
  });
};
